import styled from 'styled-components';

const EBarSCOAnnouncementsResultDiv = styled.div`
  width: 100%;
`;

EBarSCOAnnouncementsResultDiv.displayName = 'EBarSCOAnnouncementsResultDiv';

export default EBarSCOAnnouncementsResultDiv;
